import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from '@/hooks/useTranslation';
import PageBackground from '@/components/common/PageBackground';
import MetricsCards from '@/components/home/MetricsCards';
import ResumeCoursesSection from '@/components/home/ResumeCoursesSection';
import AssignedCoursesSection from '@/components/home/AssignedCoursesSection';
import UnfinishedGuidesSection from '@/components/home/UnfinishedGuidesSection';
import RecommendedCoursesSection from '@/components/home/RecommendedCoursesSection';
import RecommendedGuidesSection from '@/components/home/RecommendedGuidesSection';

const HomePage: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation('home');

  const userName = user?.firstName || user?.email?.split('@')[0] || 'User';

  return (
    <PageBackground>
      {/* Welcome Section */}
      <motion.section
        className="mb-12 text-center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="inline-flex items-center gap-3 mb-4">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 rounded-2xl blur-lg opacity-50" />
            <div className="relative p-3 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl shadow-lg">
              <Sparkles className="w-8 h-8 text-white" />
            </div>
          </div>
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 dark:from-white dark:via-gray-100 dark:to-white bg-clip-text text-transparent">
              {t('welcomeUser', { name: userName })}
            </h1>
          </div>
        </div>
      </motion.section>

      {/* Metrics Cards */}
      <motion.section
        className="mb-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <MetricsCards />
      </motion.section>

      {/* Resume Courses Section */}
      <ResumeCoursesSection />

      {/* Assigned Courses Section */}
      <AssignedCoursesSection />

      {/* In-Progress Guides Section */}
      <UnfinishedGuidesSection />

      {/* Recommended Courses Section */}
      <RecommendedCoursesSection />

      {/* Recommended Guides Section */}
      <RecommendedGuidesSection />
    </PageBackground>
  );
};

export default HomePage;
